'use strict';

module.exports = {
    updateVariationSelection: function () {
        $('body').on('product:updateVariationSelection', function (e, response) {
            var variantSelections = [];
            response.product.variantSelections.forEach(function (attr) {
                variantSelections.push({
                    id: attr.id,
                    isSelected: attr.isSelected,
                    displayName: attr.displayName
                });
            });
            $('.js-notify-me').attr('data-variant-selections', JSON.stringify(variantSelections)).attr('data-sku', response.product.id);
        });
    },
    validateVariationSelected: function () {
        $('body').on('click', 'button.js-notify-me', function () {
            var variantSelections = JSON.parse($(this).attr('data-variant-selections'));
            var unselectedAttributes = [];
            variantSelections.forEach(function (variant) {
                if (!variant.isSelected) {
                    unselectedAttributes.push(variant.displayName);
                }
            });
            if (unselectedAttributes.length) {
                $('.availability-error-message').html('Please Select A ' + unselectedAttributes.join(','));
            } else {
                // launch cordial lightbox
                // eslint-disable-next-line no-lonely-if
                if (window.DIGIOH_API) {
                    window.DIGIOH_API.openBox('281404');
                }
            }
        });
    },
    updateButtons: function () {
        $('body').on('product:afterAttributeSelect', function () {
            var showNotifyMeBtn = $('.js-nm-variation-select .selected').hasClass('is-notify-me');
            if (showNotifyMeBtn) {
                $('.js-notify-me, .notify-me-bar-btn').removeClass('d-none');
                $('.js-add-to-cart, .add-to-cart-bar-btn').addClass('d-none');
            } else {
                $('.js-notify-me, .notify-me-bar-btn').addClass('d-none');
                $('.js-add-to-cart, .add-to-cart-bar-btn').removeClass('d-none');
            }
        });
    }
};
